<app-header></app-header>
<div class="mainwrapper">
  <div class="new-container">
    <!-- <mat-card class="main-title">
      <h2>User List</h2>
    </mat-card> -->
    <app-login-info></app-login-info>
    <div class="subwrapper">
     
      <div class="sub-title wrapper">
        <h2>User List</h2>
        <button mat-button class="add_btn" (click)="addBtn()">Add User</button>
      </div>
      <div class="wrapper">
        <div class="list-style2">
          <div
            class="taxonomies_liststyle"
            [ngClass]="listprogressBar == true ? 'hide' : 'show'"
          >
            <lib-listing
              class="adminlisttable_v2"
              *ngIf="tabledatatalist != null && tabledatatalist.length > 0"
              [datasource]="tabledatatalist"
              [skip]="tabledata_header_skip"
              [modify_header_array]="modify_header_array"
              [apiurl]="api_url_for_managebanner"
              [deleteendpoint]="deleteendpoint"
              [updateendpoint]="updateendpoint"
              [date_search_source]="date_search_source"
              [date_search_endpoint]="date_search_endpoint"
              [sourcedata]="tablename"
              [updatetable]="updatetable"
              [editroute]="editroute"
              [statusarr]="statusarray"
              [detail_skip_array]="tabledata_detail_skip"
              [jwttoken]="jwttokenformanagebanner"
              [search_settings]="search_settings"
              [searchendpoint]="searchendpoint"
              [sortdata]="sortdata"
              [datacollection]="datacollection"
              [date_search_source_count]="date_search_source_count"
              [libdata]="libdata"
              [limitcond]="limitcond"
              [customlistenbutton]="customlistenbutton"
              [updatetable]="taxonomy_updatetable"
              (onLiblistingButtonChange)="onLiblistingButtonChange($event)"
              (onLiblistingChange)="listenLiblistingChange($event)"
            >
            </lib-listing>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
